import React from "react";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import { STATUS_OPTIONS } from "../assign-filter-options-constant";

interface StatusFilterProps {
  value: string[];
  onChange: (selected: string[]) => void;
  isStatusEnabled: boolean;
  error?: string;
}

const AssignStatusFilter: React.FC<StatusFilterProps> = ({
  value,
  onChange,
  isStatusEnabled,
  error,
}) => {
  const handleCheckboxChange = (optionValue: string) => {
    const updated = value.includes(optionValue)
      ? value.filter((val) => val !== optionValue)
      : [...value, optionValue];
    onChange(updated);
  };

  if (!isStatusEnabled) return null;

  return (
    <div style={{ margin: "12px 4px" }}>
      <div style={{ display: "flex", gap: "90px", alignItems: "center" }}>
        {STATUS_OPTIONS.map((option) => (
          <label
            key={option.value}
            style={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <Checkbox
              checked={value.includes(option.value)}
              onChange={() => handleCheckboxChange(option.value)}
              icon={
                <span
                  style={{
                    width: "13px",
                    height: "13px",
                    border: "2px solid #bfc0c2",
                    borderRadius: "4px",
                    display: "inline-block",
                  }}
                />
              }
              checkedIcon={
                <span
                  style={{
                    width: "13px",
                    height: "13px",
                    backgroundColor: "#1976d2",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #1976d2",
                  }}
                >
                  <CheckIcon
                    style={{ fontSize: "17px", color: "#fff", fontWeight: 900 }}
                  />
                </span>
              }
            />
            {option.label}
          </label>
        ))}
      </div>
      {error && <div className="error-message" style={{textAlign:"left"}}>{error}</div>}
    </div>
  );
};

export default AssignStatusFilter;
